export var ClientConfiguation = {
  ServerExport: "Server_Export",
  ExportBatchSize: "Export-BatchSize",
  ExportRequestDelay: "Export-RequestDelay",
  TopMenuDisableHelpLink: "yes",
  NHSS_JobSearchBySchool: "NHSS_JobSearchBySchool",
  ShowObV2: "ShowObV2",
  Feature_Enhanced_Job_Approval: "feature_enhanced_job_approval",
  NewStarterFilter: "NewStarterFilter",
  Helpdesk_Link: "Helpdesk_Link",
  Helpdesk_KnowledgeHub: "Helpdesk_KnowledgeHub",
  NhssAdditionalInfo: "NhssAdditionalInfo",
  Allow_Application_Form_Removal: "Allow_Application_Form_Removal",
  // Old name of Allow_Application_Form_Removal (#2826). Only read as a fallback for users still logged in with
  // client configurations cached under the old key; remove once everyone has logged in again after the release.
  Deny_Application_Form_Removal: "Deny_Application_Form_Removal",
  BrandBuilderLoginUrl: "BrandBuilderLoginUrl",
  ShowNhsPropertyBankDetails: "ShowNhsPropertyBankDetails",
  JobAdvertUrl: "JobAdvertUrl",
  feature_enhanced_ai_job_advert: "feature_enhanced_ai_job_advert",
  ai_job_advert_prompt: "ai_job_advert_prompt",
  ai_job_advert_max_token_limit: "ai_job_advert_max_token_limit",
  IsNewCandidateSide: "IsNewCandidateSide",
  FeatureBankDetails: "Feature_BankDetails",
  Feature_InterviewComplete: "Feature_InterviewComplete",
  AdminFormSectionHeadingClasses: "AdminForm-SectionHeadingClasses",
  ShowCodeField: "ShowCodeField",
  EqualOopsDisabilityAddDontknow: "EqualOops_Disability_Add_DontKnow",
  EqualOopsRemovePreferNotToSay: "EqualOops_Remove_PreferNotTosay",
  FeatureDirectApply: "feature-direct-apply",
  FeatureIndeedDirectApply: "feature-indeed-direct-apply",
  FeatureStripe: "Feature_Stripe",
  Logos_Settings: "Logos_Settings",
  Feature_Vonq: "Feature_Vonq",
  Feature_JobType: "feature-show-jobtypes-in-assessment-form",
  Feature_private_job: "feature_private_job",
  FeatureMultiPanelShortlisting: "feature-multi-panel-shortlisting",
  FeatureFeedbackEmails: "feature-feedback-emails",
  feature_CV_Library: "feature-cv-library",
  FeatureChangeStatusWithoutSendingEmail: "feature-change-status-without-sending-email",
  Feature_ExcludeNumber_In_SectionHeader: "Feature_ExcludeNumber_In_SectionHeader",
  feature_Ranking_Start: "feature-candidate-list-number-of-ranking-stars",
  ConfigCandidateApplicationSupportingDocMaxSize: "config-candidate-application-supporting-doc-max-size",
  feature_jobadvert_copy_from_internal: "feature-jobadvert-copy-from-internal",
  feature_do_not_allow_empty_closing_date: "feature-do-not-allow-empty-closing-date",
  Feature_Cintra: "feature_cintrta",
  Feature_Cintra_File_Download: "Feature_Cintra_File_Download",
  featureOpenApi: "feature-open-api",
  FeatureVoyageCareNewStarterExtract: "feature-voyage-care-new-starter-extract",
  FeatureReorderedQuestuionNo: "feature-reordered-question-no",
  config_allow_recruiter: "config-allow-recruiter",
  restoreCandidateData: "restore-candidate-data",
  Feature_Itrent_Integration: "feature_itrent_integration",
  Feature_Itrent_Central_Service_Enabled: "config-iTrent-central-service-enabled",
  Feature_Itrent_Integration_File_Download: "feature_itrent_integration_file_download",
  feature_ESR: "feature-esr",
  config_iTrent_remove_encapsulation: "config-iTrent-remove-encapsulation",
  esrDefaultOpenings: "esr-default-opening-value",
  Feature_ESR_File_Download: "feature-esr-file-download",
  Feature_ESR_Employment_Checks_File_Download: "feature-esr-employment-checks-file-download",
  ESRVPDCode: "esr-vpd-code",
  featureAcceptDeclineInterview: "feature-accept-decline-interview",
  featureNTUDocumentExtract: "feature-NTU-doc-extract",
  loadProcessDataForNTUDataExtraction: "Load-process-data-for-NTU-data-extraction",
  showBankDetailOnStarterForm: "show_bank_detail_on_starter_form",
  isValidateNationalInsuranceNumberWithPattern: "config-validate-national-insurance-number-with-pattern",
  nationalInsuranceNumbervalidationPattern: "config-national-insurance-number-validation-pattern",
  AllowBankDetailStudentLoanField: "config-bank-detail-student-loan",
  ConfigStarterFormProposedStartDateFieldId: "config-starter-form-proposed-start-date-fieldId",
  ConfigStarterFormStartedApplicationStatusId: "config-starter-form-started-application-statusId",
  FeatureCRM: "feature-crm",
  JTURL: "JTURL",
  hideDisplayOrderFromLocation: "config_hide_display_order_from_location_setup",
  disableCalendarShowAssignEventToCampaign: "config-disable-calendar-show-assign-event-to-campaign",
  disableCalendarShowLinkEventToAllJobsAtLocation: "config-disable-calendar-show-link-event-to-all-jobs-at-location",
  hide_attention_grabber: "config-add-job-hide-attention-grabber",
  enableResetApprovalButtonForceFully: "config-add-job-enable-reset-approval-button-force-fully",
  hide_advert_doc_library_search: "config-add-job-hide-advert-doc-library-search",
  prevent_doc_library_upload: "config-prevent-doc-library-upload",
  FeatureJobAdvertPreviewToken: "feature-job-advert-preview-token",
  check_feature_advert_exists: "config-add-job-check-advert-exists-before-approval",
  addJobRequisitionAttachmentsInstruction: "config-add-job-requisition-attachments-instruction",
  addJobRequisitionAttachmentsHeading: "config-add-job-requisition-attachments-heading",
  FeatureAlphabetAnonymousSearch: "featureAlphabetAnonymousSearch",
  featureRedeployment: "feature-redeployment",
  FeatureReportBuilder: "feature-report-builder",
  config_import_candidate_send_in_complete_application_email: "config-import-candidate-send-in-complete-application-email",
  FeatureGasIcon: "config-list-candidate-use-gas-icon",
  GasIconHoverText: "config-list-candidate-gas-icon-hover-text",
  ConfigCandidateListShowJobAdvertiseButton: "config-candidate-list-show-job-advertise-button",
  feature_panel_shortlisting_office_use_only: "feature-panel-shortlisting-office-use-only",
  feature_auto_save: "feature-auto-save",
  ConfigPanelShortlistingCustomScore: "config-panel-shortlisting-custom-score",
  FeatureIndexDbForShortlisting: "feature-index-db-for-shortlisting-forms",
  check_advert_exists_before_approval: "config-add-job-check-advert-exists-before-approval",
  FeatureStandardisedJobStatTiles: "config-job-list-standardised-job-stat-tiles",
  FeatureTrustId: "feature-trustid",
  DbsProvider: "config-employment-checks-dbs-provider",
    RtwProvider: "config-employment-checks-rtw-provider",
    FeatureEnableDbsAdultFirst: "feature-enable-dbs-adult-first",
    FeatureTalogy: "feature-talogy-assessment",
    FeatureTalogyAssessment: "feature-talogy-assessment",
    FeatureApplicationStatusStatTiles: "config-candidate-list-application-status-stat-tiles",
    FeatureEnableTrustIdYotiDBSMerge: "feature-enable-trustId-yoti-dbs-merge",
    FeatureBlobStorage: "feature-blob-storage",
      FeaturePartnerPsychometricAssessment: "feature-partner-psychometric-assessment",

    featureMyTasks: "feature-my-tasks",
  feature_download_documents: "feature-download-documents",
  configStarterFormEnforceMoneyFieldMinValue: "config-starter-form-enforce-money-field-min-value",
    FeatureCopyFromEmployment: "config-reference-copy-from-employment",
    FeatureRefereeDocumentUpload: "feature-referee-document-upload",
    enableSalaryBandYear: "config-settings-enable-salary-band-year",

    Feature2FA: "feature-2fa",
    featureSonaIntegration: "feature-sona-integration",
    configCheckBreachPassword: "config-enable-breached-password-check",
    FeatureEditDirectApplyApplicationAfterSubmission: "EditDirectApplyApplicationAfterSubmission"


}
